import { Injectable } from '@angular/core';
import { Observable, Subscription, Subject } from 'rxjs/Rx';

import { ConfigHelper } from './config.helper';
import { ISignalRConnection, SignalR, BroadcastEventListener } from "ng2-signalr";

@Injectable()
export class SignalRService {

    private signalRConnection: ISignalRConnection;
    onFreeze$ = new BroadcastEventListener<TestTakerHubDto[]>('onFreeze');
    onUnFreeze$ = new BroadcastEventListener<TestTakerHubDto[]>('onUnFreeze');
    onNewConnectionEstablished$ = new Subject<any>();

    constructor(
        private signalR: SignalR
    ) {
    }

    initializeConnection() {
        Observable
            .defer(() => this.signalR.connect())
            .retryWhen(errors => errors.delay(20000))
            .subscribe(
                connection => {
                    this.signalRConnection = connection;
                    this.signalRConnection.listen(this.onFreeze$);
                    this.signalRConnection.listen(this.onUnFreeze$);
                    this.onNewConnectionEstablished$.next();
                    connection.status
                        .subscribe(status => {
                            // disconnected
                            if (status.value === 4) {
                                this.initializeConnection();
                            }
                        });
                    }
            );
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/signalR.service.ts